// extracted by mini-css-extract-plugin
module.exports = {"ErrorText":"styles_ErrorText__2-tAz"};